import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';

const TresLechesConfigurator = ({
  tresLechesDialog,
  setTresLechesDialog,
  selectedCake,
  tresLechesConfig,
  setTresLechesConfig,
  calculateTresLechesPrice,
  isValidCombo,
  addTresLechesToCart
}) => {
  return (
    <Dialog open={tresLechesDialog} onOpenChange={setTresLechesDialog}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-chocolate flex items-center gap-2">
            🍰 Tres Leches
          </DialogTitle>
          <DialogDescription>
            Bizcocho esponjoso bañado en tres leches. Selecciona tu tamaño y sabor.
          </DialogDescription>
        </DialogHeader>

        {selectedCake && selectedCake.isTresLeches && (
          <div className="space-y-6 py-4">
            <div className="bg-red-50 border-2 border-red-300 rounded-lg p-4">
              <p className="text-sm font-bold text-red-900 flex items-center gap-2">
                <span className="text-xl">⏰</span>
                Aviso Importante
              </p>
              <p className="text-sm text-red-800 mt-2">
                Este pedido requiere al menos 24 horas para su preparación y debe recibir confirmación de inicio de preparación
              </p>
            </div>
            
            <div className="space-y-3">
              <Label className="text-base font-semibold">¿Cómo deseas ordenar?</Label>
              <div className="grid grid-cols-2 gap-3">
                <button
                  type="button"
                  onClick={() => setTresLechesConfig({ ...tresLechesConfig, isCombo: false })}
                  className={`p-4 rounded-xl border-2 transition-all ${
                    !tresLechesConfig.isCombo 
                      ? 'border-amber-500 bg-amber-50' 
                      : 'border-gray-200 hover:border-amber-300'
                  }`}
                >
                  <div className="font-bold text-chocolate">Individual</div>
                  <div className="text-xs text-chocolate-light">Un solo tamaño</div>
                </button>
                <button
                  type="button"
                  onClick={() => setTresLechesConfig({ ...tresLechesConfig, isCombo: true })}
                  className={`p-4 rounded-xl border-2 transition-all relative ${
                    tresLechesConfig.isCombo 
                      ? 'border-green-500 bg-green-50' 
                      : 'border-gray-200 hover:border-green-300'
                  }`}
                >
                  <div className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-0.5 rounded-full">
                    🎁 PROMO
                  </div>
                  <div className="font-bold text-chocolate">Combo</div>
                  <div className="text-xs text-chocolate-light">Pequeña + Grande</div>
                  <div className="text-sm font-bold text-green-600">desde $28</div>
                </button>
              </div>
            </div>

            {!tresLechesConfig.isCombo && (
              <>
                <div className="space-y-3">
                  <Label className="text-base font-semibold">Selecciona el tamaño</Label>
                  <div className="grid grid-cols-2 gap-3">
                    {selectedCake.sizes.map(size => (
                      <button
                        key={size.id}
                        type="button"
                        onClick={() => setTresLechesConfig({ ...tresLechesConfig, singleSize: size.id })}
                        className={`p-4 rounded-xl border-2 transition-all ${
                          tresLechesConfig.singleSize === size.id 
                            ? 'border-amber-500 bg-amber-50' 
                            : 'border-gray-200 hover:border-amber-300'
                        }`}
                      >
                        <div className="font-bold text-chocolate">{size.name}</div>
                        <div className="text-xs text-chocolate-light">{size.portions}</div>
                        <div className="text-xl font-bold text-caramel mt-1">${size.price}</div>
                      </button>
                    ))}
                  </div>
                </div>

                <div className="space-y-3">
                  <Label className="text-base font-semibold">Selecciona el sabor</Label>
                  <div className="grid grid-cols-2 gap-2">
                    {selectedCake.flavors.map(flavor => (
                      <button
                        key={flavor.id}
                        type="button"
                        onClick={() => setTresLechesConfig({ ...tresLechesConfig, singleFlavor: flavor.id })}
                        className={`p-3 rounded-lg border-2 text-sm font-medium transition-all ${
                          tresLechesConfig.singleFlavor === flavor.id 
                            ? 'border-amber-500 bg-amber-50 text-amber-700' 
                            : 'border-gray-200 hover:border-amber-300 text-chocolate'
                        }`}
                      >
                        {flavor.name}
                      </button>
                    ))}
                  </div>
                </div>

                {tresLechesConfig.singleFlavor && (
                  <div className="bg-amber-50 rounded-xl p-4 border border-amber-200">
                    <div className="text-sm font-semibold text-chocolate mb-2">Tu selección:</div>
                    <div className="text-sm text-chocolate-light">
                      📏 {selectedCake.sizes.find(s => s.id === tresLechesConfig.singleSize)?.name} - 
                      🍰 {selectedCake.flavors.find(f => f.id === tresLechesConfig.singleFlavor)?.name.replace(' (+$2)', '')}
                    </div>
                    <div className="text-2xl font-bold text-amber-600 text-center mt-3">
                      ${calculateTresLechesPrice().toFixed(2)}
                    </div>
                  </div>
                )}
              </>
            )}

            {tresLechesConfig.isCombo && (
              <>
                <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-xs">
                  <p className="font-semibold text-green-800 mb-1">🎁 Reglas del Combo $28:</p>
                  <ul className="text-green-700 space-y-1">
                    <li>• <strong>Clásica y Chocolate:</strong> Puedes mezclar sabores</li>
                    <li>• <strong>Maracuyá y Ron Pope:</strong> Ambas deben ser del mismo sabor</li>
                  </ul>
                </div>

                <div className="space-y-3">
                  <Label className="text-base font-semibold flex items-center gap-2">
                    <span className="bg-amber-500 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">1</span>
                    Sabor para la Pequeña
                  </Label>
                  <div className="grid grid-cols-2 gap-2">
                    {selectedCake.flavors.map(flavor => (
                      <button
                        key={flavor.id}
                        type="button"
                        onClick={() => setTresLechesConfig({ ...tresLechesConfig, medianaFlavor: flavor.id })}
                        className={`p-3 rounded-lg border-2 text-sm font-medium transition-all ${
                          tresLechesConfig.medianaFlavor === flavor.id 
                            ? 'border-amber-500 bg-amber-50 text-amber-700' 
                            : 'border-gray-200 hover:border-amber-300 text-chocolate'
                        }`}
                      >
                        {flavor.name}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="space-y-3">
                  <Label className="text-base font-semibold flex items-center gap-2">
                    <span className="bg-amber-500 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">2</span>
                    Sabor para la Grande
                  </Label>
                  <div className="grid grid-cols-2 gap-2">
                    {selectedCake.flavors.map(flavor => {
                      const medianaFlavor = selectedCake.flavors.find(f => f.id === tresLechesConfig.medianaFlavor);
                      const isPremiumMismatch = medianaFlavor?.comboGroup === 'premium' && 
                        flavor.comboGroup === 'premium' && 
                        flavor.id !== tresLechesConfig.medianaFlavor;
                      
                      return (
                        <button
                          key={flavor.id}
                          type="button"
                          onClick={() => setTresLechesConfig({ ...tresLechesConfig, grandeFlavor: flavor.id })}
                          disabled={isPremiumMismatch}
                          className={`p-3 rounded-lg border-2 text-sm font-medium transition-all ${
                            tresLechesConfig.grandeFlavor === flavor.id 
                              ? 'border-amber-500 bg-amber-50 text-amber-700' 
                              : isPremiumMismatch
                                ? 'border-gray-100 bg-gray-50 text-gray-300 cursor-not-allowed'
                                : 'border-gray-200 hover:border-amber-300 text-chocolate'
                          }`}
                        >
                          {flavor.name}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {tresLechesConfig.medianaFlavor && tresLechesConfig.grandeFlavor && (
                  <div className={`rounded-xl p-4 border ${isValidCombo() ? 'bg-gradient-to-r from-green-50 to-emerald-50 border-green-200' : 'bg-amber-50 border-amber-200'}`}>
                    <div className={`text-sm font-semibold mb-2 ${isValidCombo() ? 'text-green-800' : 'text-amber-800'}`}>
                      {isValidCombo() ? '🎁 Tu Combo con Descuento:' : '📦 Tu Pedido:'}
                    </div>
                    <div className={`text-sm space-y-1 ${isValidCombo() ? 'text-green-700' : 'text-amber-700'}`}>
                      <div>📦 Pequeña: {selectedCake.flavors.find(f => f.id === tresLechesConfig.medianaFlavor)?.name.replace(' (+$2)', '')}</div>
                      <div>📦 Grande: {selectedCake.flavors.find(f => f.id === tresLechesConfig.grandeFlavor)?.name.replace(' (+$2)', '')}</div>
                    </div>
                    {!isValidCombo() && (
                      <p className="text-xs text-amber-600 mt-2">
                        ⚠️ Esta combinación no aplica para la promoción de $28
                      </p>
                    )}
                    <div className="flex items-center justify-center gap-2 mt-3">
                      {isValidCombo() && <span className="text-sm text-gray-400 line-through">$35</span>}
                      <span className={`text-2xl font-bold ${isValidCombo() ? 'text-green-600' : 'text-amber-600'}`}>
                        ${calculateTresLechesPrice().toFixed(2)}
                      </span>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        <DialogFooter>
          <Button
            onClick={addTresLechesToCart}
            disabled={tresLechesConfig.isCombo 
              ? !tresLechesConfig.medianaFlavor || !tresLechesConfig.grandeFlavor
              : !tresLechesConfig.singleFlavor
            }
            className={`w-full py-6 text-lg ${
              (tresLechesConfig.isCombo 
                ? tresLechesConfig.medianaFlavor && tresLechesConfig.grandeFlavor
                : tresLechesConfig.singleFlavor)
                ? 'bg-amber-500 hover:bg-amber-600 text-white' 
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            {(tresLechesConfig.isCombo 
              ? tresLechesConfig.medianaFlavor && tresLechesConfig.grandeFlavor
              : tresLechesConfig.singleFlavor)
              ? `🍰 Agregar al Pedido - $${calculateTresLechesPrice().toFixed(2)}` 
              : 'Selecciona los sabores'
            }
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default TresLechesConfigurator;
